import * as React from 'react';
import { useGenericState } from 'src/Library/UseGenericState';
import { message } from 'antd';
import {
  PropsTypes,
  FuncTypes,
} from './SEBulkShipment.types';
import SEBulkShipmentHtml from './SEBulkShipment.html';
import constants from './SEBulkShipment.contants';
import { downloadFileData } from 'src/utils/utils';
import { downloadSEBulkShipmentSample, postSEBulkShipmentUpload } from 'src/api/shipmentExecution';
import { getFormattedDateTime } from 'src/Library/Helper';
import useS3Upload from 'src/hooks/useS3Upload';
import { REQUEST_STATUS } from '../../BulkRequest/BulkRequestUtils';

const SEBulkShipment: React.FC<PropsTypes> = (props) => {
  const { onClose, getRequestObject } = props;

  const initialState = {
    fileName: '' as string,
    s3UploadMap: [] as any[],
    errorData: [] as any[],
    isLoading: false,
    isErrorModalVisible: false,
  };

  const [state, setState] = useGenericState<typeof initialState>(initialState);

  const { fileName, s3UploadMap, isErrorModalVisible, isLoading } = state;
  const uploadFileToS3Api = useS3Upload('shipment-execution');
  React.useEffect(() => {
    if (!uploadFileToS3Api.uploadState.isUploading && uploadFileToS3Api.uploadState.s3File.s3Link) {
      setState({
        s3UploadMap: [uploadFileToS3Api.uploadState.s3File.s3Link],
        fileName: uploadFileToS3Api.uploadState.s3File.name,
        isLoading: false
      })
    }
  }, [uploadFileToS3Api.uploadState.isUploading])

  const handleDownloadLineItemsExcel = async () => {
    if (isLoading) {
      return;
    }
    const payload = {};
    const downloadResponse = await downloadSEBulkShipmentSample();
    if (downloadResponse.isSuccess) {
      downloadFileData(
        downloadResponse.data,
        downloadResponse.filename || `shipment-execution - ${getFormattedDateTime('DD-MM-YYYY')}`,
        true,
      );
      message.success('Downloaded successfully');
    } else {
      message.error(downloadResponse.errorMessage);
    }
  };

  const getS3UploadLink = async (fileArray) => {
    const s3Links = [] as any[];
    if (fileArray?.length) {
      setState({
        isLoading: true,
      });
      await uploadFileToS3Api.uploadToS3(fileArray[0]);
    }
  };

  const handleSubmit = async () => {
    if (!s3UploadMap?.length) {
      message.error('Please Upload a file');
      return;
    }
    setState({
      isLoading: true,
    });
    handleSubmitLinks(s3UploadMap);
  };

  const handleSubmitLinks = async (s3UploadMap: any[]) => {
    const getLinks = s3UploadMap;
    const payload = {
      awsUrl: constants.isMultiple ? getLinks : getLinks?.pop(),
      fileName,
    };
    const response = await postSEBulkShipmentUpload(payload);
    if (response.isSuccess) {
      if (response?.data?.failureArray?.length) {
        const errorArray = response?.data?.failureArray
        setState({
          errorData: errorArray
        });
        handleErrorModal();
        return;
      } else {
        message.success('Shipment(s) created successfully.');
        getRequestObject({
          fileName,
          id: response.data?.data?.requestId,
          status: REQUEST_STATUS.PENDING,
        });
        handleClose(true);
      }
      handleClose();
    } else {
      if (response?.data?.failureArray?.length) {
        setState({
          errorData: response?.data?.failureArray?.length
        })
        handleErrorModal();
      } else if (response?.errorMessage) {
        message.error(response?.errorMessage);
      }
    }
    setState({
      isLoading: false,
    });
  };

  const handlleFileData = (data: any) => {
    getS3UploadLink(data);
  };

  const handleClose = (isReload = false) => {
    onClose(isReload);
  };

  const handleErrorModal = (isClose = false) => {
    setState({
      isErrorModalVisible: !isErrorModalVisible,
    });
    if (isClose) handleClose(true)
  };

  const getFunctions = (): FuncTypes => {
    return {
      handleDownloadLineItemsExcel,
      handleSubmit,
      handleClose,
      handlleFileData,
      handleErrorModal,
    };
  };
  return SEBulkShipmentHtml(props, state, constants, getFunctions());
};

export default SEBulkShipment;